import React from "react";
import { Box } from "@mui/joy";
import { trainingsEditorDockedActionsBarSx } from "../../../styles/globalStyles";

export type TrainingsEditorDockedActionsProps = {
  children: React.ReactNode;
};

export default function TrainingsEditorDockedActions({
  children,
}: TrainingsEditorDockedActionsProps) {
  return <Box sx={trainingsEditorDockedActionsBarSx}>{children}</Box>;
}
